import React, { useEffect, useRef, useState } from "react";
export default function Chat() {
  const socket = useRef(null);
  const reconnectTimer = useRef(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [username, setUsername] = useState("Guest");
  const [connected, setConnected] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    socket.current = new WebSocket("wss://chat.hyperdish.com/chat");

    socket.current.onopen = () => {
      console.log("Connected");
      setConnected(true);
      if (reconnectTimer.current) {
        clearTimeout(reconnectTimer.current);
      }
    };

    socket.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setMessages((prev) => [...prev, data]);
    };

    socket.current.onclose = () => {
      console.log("Disconnected");
      setConnected(false);
    };

    socket.current.onerror = (err) => {
      console.error(err);
    };

    return () => {
      socket.current?.close();
    };
  }, []);

  const sendMessage = () => {
    if (!socket.current) {
      console.log("Socket not created");
      return;
    }

    if (socket.current.readyState !== WebSocket.OPEN) {
      console.log("Socket not connected");
      return;
    }

    socket.current.send(
      JSON.stringify({
        user: username,
        message: message,
      }),
    );
    setMessage("");
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
      clearTimeout(reconnectTimer.current);
      socket.current?.close();
    };
  }, []);

  return (
    <div className="container mt-4">
      <nav className="navbar navbar-expand-xl navbar-dark bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="#top">
            Navbar
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarLight"
            aria-controls="navbarLight"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse show" id="navbarLight">
            <ul className="navbar-nav me-auto mb-2 mb-xl-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  Features
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link disabled"
                  href="#"
                  tabIndex={-1}
                  aria-disabled="true"
                >
                  Disabled
                </a>
              </li>
            </ul>
            <form className="d-flex">
              <input
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
              <button className="btn btn-outline-primary" type="submit">
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>

      <h4>{connected ? "Connected" : "Disconnected"}</h4>
      <div className="card">
        <div
          className="card-body"
          style={{ height: "400px", overflowY: "scroll" }}
        >
          {messages.map((m, i) => (
            <div key={i}>
              <b>{m.user}</b>: {m.message}
            </div>
          ))}
        </div>
      </div>
      <div className="mt-3">
        <label class="form-label">!@Enter your desired username</label>

        <div class="input-group">
          <span class="input-group-text" id="input-group-left-example">
            @
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            aria-label="Username"
            aria-describedby="input-group-left"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div class="input-group">
          <span class="input-group-text" id="input-group-left-example">
            #
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Message"
            aria-label="Message"
            aria-describedby="input-group-left"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <button className="btn btn-primary" onClick={sendMessage}>
          Send
        </button>
      </div>
    </div>
  );
}
